import * as React from "react";
const UNITS = {
  NANOSECONDS: "nanoseconds",
  MICROSECONDS: "microseconds",
  MILLISECONDS: "milliseconds",
  SECONDS: "seconds",
  MINUTES: "minutes",
  HOURS: "hours",
  DAYS: "days"
};
const TimeUnit = ({ value, unit, zeroIsNever = true }) => {
  if (value === 0 && zeroIsNever) {
    return /* @__PURE__ */ React.createElement("span", null, "Never");
  }
  return /* @__PURE__ */ React.createElement("span", null, value, "\xA0", UNITS[unit]);
};
export default TimeUnit;
